export default __webpack_public_path__ + "static/media/add2.ed43ff43.gif";